import React from 'react';
import { SignUp as SignUpComponent } from '@clerk/clerk-react';
import { clerkSignInUpElements, clerkVariables } from '../variables/clerk';

const SignUp = () => {
    return (
        <div className="auth-container">
            <div className="auth-column">
                <SignUpComponent
                    path="/sign-up"
                    routing="path"
                    signInUrl="/sign-in"
                    appearance={{
                        elements: {
                            ...clerkSignInUpElements,
                            form: 'hidden',
                            dividerRow: 'hidden',
                        },
                        variables: clerkVariables,
                    }}
                />
                <div className="clerk-card-footer">
                    Need access? Reach out to:
                    <ul className="clerk-card-contact-list">
                        <li>
                            <a href="mailto:annemie.bressinck@ab-inbev.com">
                                Annemie Bressinck
                            </a>{' '}
                            for Netherlands, BeLux, or France
                        </li>
                        <li>
                            <a href="mailto:yuliia.koviazina@abinbevefes.com.ua">
                                Yuliia Koviazina
                            </a>{' '}
                            for all other countries
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};
export default SignUp;
